import React, { FunctionComponent } from 'react';
import type { RecruitmentRegisterModalProps, RecruitmentRegisterModalState } from './types';
import { RegisterTextBox } from '../../atoms/registerTextBox';
import { RegisterBirthdaySelectBox } from '../../atoms/registerBirthdaySelectBox';
import { RegisterSelectBox } from '../../atoms/registerSelectBox';

type Props = RecruitmentRegisterModalProps & {
  state: RecruitmentRegisterModalState;
  isSubmitting: boolean;
  onChanged: (name: string, value: any) => void;
  onClicked: () => void;
  handleOpenNextSection: (e: React.MouseEvent<HTMLInputElement>) => void;
  handleOauthsLinkClick: (provider: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  occupations,
  preferredOccupations,
  occupationDetails,
  prefectures,
  handleRegisterModalOpen,
  handleSwitchLoginModalOpen,
  graduationArray,
  graduationAnnotaion,
  isRegisterOpenModal,
  redirectUrl,
  handleFlash,
  lineIcon,
  dataCategory,
  dataValue,
  isBrandPage,
  isStoppedFv,
  state,
  isSubmitting,
  onChanged,
  onClicked,
  handleOpenNextSection,
  handleOauthsLinkClick,
}) => {
  const shouldShowStoppedFvTitle = !isBrandPage && isStoppedFv;

  return (
    <>
      <form
        className={`recruitment__showmodal gtm-popup-view-count ${state.isNextSection ? 'scroll' : ''} ${isRegisterOpenModal ? 'open' : ''} ${state.isHeightTooShort ? 'height' : ''}`}
        id="register-modal"
        data-event-name='popup on screen'
        data-category={dataCategory}
        data-value='register'
        onSubmit={(e) => e.preventDefault()}
        data-recruitmentid={recruitmentId}
        data-companyid={companyId}
      >
        <div className="recruitment__showmodal__wrapper">
          <h3 className="recruitment__showmodal__wrapper__title">
            <div onClick={handleRegisterModalOpen} className="mask">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z" fill="#19190F" />
              </svg>
            </div>
            <p className="title">新規登録</p>
          </h3>
          <div className={`recruitment__showmodal__box ${state.isNextSection ? 'scroll' : ''}`}>
            {isBrandPage ? (
              <p className="recruitment__showmodal__box__title">
                通知登録が完了しました！<br />
                会員登録をすると、他のブランドの新着募集やスカウトも受け取れます。
                <a href="#" className="link" onClick={handleSwitchLoginModalOpen} data-event="click" data-category={dataCategory} data-value={dataValue.toLogin}>
                  すでにアカウントをお持ちの方はこちら
                </a>
              </p>
            ) : shouldShowStoppedFvTitle ? (
              <p className="recruitment__showmodal__box__title">
                通知登録が完了しました！<br />
                会員登録をすると、スカウトを受け取ったり、履歴書や職務経歴書を作成することができます。
                <a href="#" className="link" onClick={handleSwitchLoginModalOpen} data-event="click" data-category={dataCategory} data-value={dataValue.toLogin}>
                  すでにアカウントをお持ちの方はこちら
                </a>
              </p>
            ) : (
              <p className="recruitment__showmodal__box__title">
                エントリーするには会員登録が必要です。<br />
                以下の記入項目を入力して会員登録をお願いします。<br />
                SNSで登録する場合は該当のボタンから遷移してください。<br />
                <a href="#" className="link" onClick={handleSwitchLoginModalOpen} data-event="click" data-category={dataCategory} data-value={dataValue.toLogin}>
                  すでにアカウントをお持ちの方はこちら
                </a>
              </p>
            )}
            <div className="recruitment__showmodal__box__sns">
              <p className="title">SNSで登録</p>
              <div className="btns">
                <button
                  type="button"
                  onClick={() => handleOauthsLinkClick('line')}
                  className="btns--single line"
                  data-event='click'
                  data-category={dataCategory}
                  data-value={dataValue.line}
                >
                  <img src={lineIcon} alt="READY TO FASHION Line登録" className="login-modal-button-item-box-inner-icon line" />
                  <span className="text">LINEで登録</span>
                </button>
                <button
                  type="button"
                  onClick={() => handleOauthsLinkClick('apple')}
                  className="btns--single apple"
                  data-event='click'
                  data-category={dataCategory}
                  data-value={dataValue.apple}
                >
                  <i className="fab fa-apple login-modal-button-item-box-inner-icon"></i>
                  <span className="text">Appleで登録</span>
                </button>
              </div>
            </div>
            <p className="recruitment__showmodal__box__section">もしくは</p>
            <div className="recruitment__showmodal__box__form">
              <p className="title">メールアドレスで登録</p>
              <RegisterTextBox name='email' label='メールアドレス' type='email' onChanged={onChanged} isNecessary placeholder='（例）takano@example.co.jp' width='long' className='textbox' annotation='※企業との連絡手段にもなるので正確なメールアドレスで設定してください' />
              <RegisterTextBox name='password' label='パスワード' type='password' onChanged={onChanged} isNecessary width='short' className='textbox' annotation='※パスワードは6文字以上にしてください' />
              <div className={`next ${state.isNextSection ? 'active' : ''}`} id="next">
                <RegisterTextBox name='name' label='氏名' onChanged={onChanged} isNecessary width='name' className='textbox' />
                <RegisterBirthdaySelectBox name='birthday' label='生年月日' onChanged={onChanged} isNecessary className='textbox' />
                <RegisterSelectBox name='occupation' label='直近の職種（大カテゴリー）' onChanged={onChanged} isNecessary array={occupations} className='textbox' width='short' arrow='arrow' select='select' annotation='※在学中の方は学生を選択してください' />
                {state.occupation !== '15' && (
                  <RegisterSelectBox name='occupationDetail' label='直近の職種（小カテゴリー）' onChanged={onChanged} array={occupationDetails} parentId={state.occupation} className='textbox' width='long' arrow='arrow' select='select' />
                )}
                {state.occupation === '15' && (
                  <RegisterSelectBox name='graduationYear' label='卒業予定年' onChanged={onChanged} isNecessary array={graduationArray} annotation={`現在、大学3年生の方は${graduationAnnotaion}年卒です(4年制の場合)`} className='textbox' width='long' arrow='arrow' select='select' />
                )}
                <RegisterSelectBox name='preferredOccupation' label='希望の職種（大カテゴリー）' onChanged={onChanged} isNecessary array={preferredOccupations} className='textbox' width='short' arrow='arrow' select='select' />
                <RegisterSelectBox name='preferredOccupationDetail' label='希望の職種（小カテゴリー）' onChanged={onChanged} array={occupationDetails} parentId={state.preferredOccupation} className='textbox' width='long' arrow='arrow' select='select' />
                <RegisterSelectBox name='prefecture' label='希望勤務地' onChanged={onChanged} isNecessary array={prefectures} className='textbox' width='small' arrow='arrow' select='select' />
                <RegisterSelectBox name='scoutFlag' label='スカウト' onChanged={onChanged} isNecessary array={[[1, '受け取る'], [0, '受け取らない']]} className='textbox' width='medium' arrow='arrow' select='select' />
                <label htmlFor="agreement" className="textbox last">
                  <p className="label--checkbox">
                    <input name="agreement" type="checkbox" id="agreement" onChange={onClicked} checked={state.formState.agreement} />
                    <span>
                      <a href="/users/terms" target="_blank" className="link">ユーザー向け利用規約</a> 、<a href="/privacy" target="_blank" className="link">プライバシーポリシー</a> に同意する
                    </span>
                  </p>
                </label>
                <p className="annotation">※お預かりしたお客様の個人情報は、弊社からお客様へのご連絡のために使用します。法令に定める場合を除き、第三者に対して個人情報の提供・開示する事はありません。</p>
              </div>
              <input
                  type="submit"
                  onClick={handleOpenNextSection}
                  className="recruitment__showmodal__box__form--submit"
                  value={state.submitText} data-event={state.dataEventRegister}
                  data-category={state.dataCategoryRegister}
                  data-value={state.dataValueRegister}
                  disabled={state.isNextSection && isSubmitting}
                />
            </div>
          </div>
        </div>
      </form>
      <div onClick={handleRegisterModalOpen} className={`recruitment__showmodal--bg ${isRegisterOpenModal ? 'open' : ''}`}></div>
    </>
  );
};
